// ENG-20927 PDF gated behind MpfAttachments.allowPdf; was re-enabled in ENG-17168, removed in ENG-20629
export const ACCEPT_ATTR = 'image/jpeg,image/png,image/tiff,.doc,.docx';

export const MAX_FILES_LIMIT = 10;

export type MpfFileUploadModelValue = File[];

export interface MpfFileUploadProps {
  accept?: string;
  chooseFileText?: string;
  chooseMoreFilesText?: string;
  countLabel?: string;
  disabled?: boolean;
  dropInstructionText?: string;
  errorId?: string | null;
  filesCount?: number;
  hintId?: string | null;
  id: string;
  maxFiles?: number;
  modelValue: MpfFileUploadModelValue;
  multiple?: boolean;
  noFileText?: string;
}

export const mpfFileUploadDefaults = {
  accept: ACCEPT_ATTR,
  maxFiles: MAX_FILES_LIMIT,
  hintId: null,
  errorId: null,
  disabled: false,
  chooseFileText: 'Choose file',
  chooseMoreFilesText: 'Add another file',
  dropInstructionText: 'or drop file',
  noFileText: 'No file chosen',
  countLabel: 'files selected',
  multiple: true,
};
